import type { PriorSubmissions } from '@axiom/validation';
import { Api } from '@axiom/ui';

import { EnvUtil } from '../utils/env-util';

class PriorSubmissionsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readPriorSubmissions(submissionId: string, candidateId: string) {
    return super.read<{ data: PriorSubmissions }>({
      endpoint: `/submissions/${submissionId}/candidates/${candidateId}/priorSubmissions`,
      method: 'GET',
    });
  }

  async refreshPriorSubmissions(submissionId: string, candidateId: string) {
    return super.invalidate(
      `/submissions/${submissionId}/candidates/${candidateId}/priorSubmissions`
    );
  }
}

export const PriorSubmissionsApi = new PriorSubmissionsApiClass();
